export default __webpack_public_path__ + "static/media/ic_add_user.fe97fa29.svg";